<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="contduct">
          <jm-tableList
            :url="`index/student/snapshotList/crmid/${$route.params.crmid}`"
            :refresh.sync="refresh">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="80"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <router-link :to="{ name: 'resourceSnapshotView', params: { id: scope.row.id, crmid: $route.params.crmid }}">
                  <el-button
                    type="primary"
                    size="small">查看</el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false
    };
  },
  methods: {
  },
  mounted() {
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
};
</script>

<style>
</style>
